import { communicationsApi } from '@app/services'
import { isBuyerView } from '@app/utils'
import { isImpersonatedB2BSession } from '@app/utils/token/isImpersonatedB2BSession'

import { SendCallNotificationRequest } from './types'

export const sendCallNotification = async ({
  conversationId,
  suggestedActionId,
  toParticipantId,
}: SendCallNotificationRequest) => {
  if (isBuyerView() || isImpersonatedB2BSession()) {
    return null
  }

  await communicationsApi.post(
    `/chat/${conversationId}/send/systemnotification/call`,
    {
      suggestedActionId,
      toParticipantId,
    }
  )
}
